module.exports = __webpack_public_path__ + "static/grung_orange_dahtenkhan-7c6931fd8ab9b547918861a60644e86f.jpg";